import type { PropDefinition } from 'src/components/props-table';
import { AccessTokenDescription, WidgetSessionScope } from './components';
export const scopes: WidgetSessionScope[] = [];
export const props: PropDefinition[] = [{
  name: 'authToken',
  typeSimple: 'AuthToken',
  type: 'string | (() => Promise<string>)',
  required: true,
  description: <AccessTokenDescription scopes={scopes} />
}];